export interface NotificationHistoryFilter {
  startDate?: Date;
  endDate?: Date;
  channelId?: number;
  statusId?: number;
  pageNumber: number;
  pageSize: number;
}

export interface NotificationHistory {
  id: number;
  userId: number;
  userName: string;
  notificationChannelId: number;
  channelName: string;
  statusId: number;
  statusName: string;
  type: string;
  when: Date;
  custom?: string;
}

export interface NotificationHistoryResponse {
  notifications: NotificationHistory[];
  totalCount: number;
  statistics: NotificationStatistics;
}

export interface NotificationStatistics {
  totalSent: number;
  totalFailed: number;
  totalPending: number;
  successRate: number;
}

export enum NotificationChannel {
  None = 0,
  App = 1,
  Email = 2,
  Teams = 3
}

export enum NotificationStatus {
  Pending = 0,
  Sent = 1,
  Failed = 2
}

export enum DateRangePreset {
  Last24Hours = 'last24Hours',
  Last7Days = 'last7Days',
  Last15Days = 'last15Days',
  Last30Days = 'last30Days',
  Last6Months = 'last6Months',
  Custom = 'custom'
}